import { useEffect, useState } from "react"

const TRANSITION_MS = 750

export default function useAccordionHeight(ref, isOpen) {
    const [height, setHeight] = useState(0)
    const [overflow, setOverflow] = useState("hidden")

    useEffect(() => {
        const el = ref.current
        if (!el) {
            setHeight(0)
            return
        }

        if (!isOpen) {
            setHeight(0)
            return
        }

        let raf = null
        const measure = () => {
            if (raf) return
            raf = requestAnimationFrame(() => {
                raf = null
                if (!el) return
                const children = el.children
                if (children.length === 0) {
                    setHeight(0)
                    return
                }
                const last = children[children.length - 1]
                const elTop = el.getBoundingClientRect().top
                const lastBottom = last.getBoundingClientRect().bottom
                const target = Math.max(0, Math.round(lastBottom - elTop))
                setHeight(prev => (prev === target ? prev : target))
            })
        }

        measure()

        if (typeof ResizeObserver === "undefined") {
            window.addEventListener("resize", measure)
            return () => {
                window.removeEventListener("resize", measure)
                if (raf) cancelAnimationFrame(raf)
            }
        }

        const ro = new ResizeObserver(measure)
        Array.from(el.children).forEach(child => {
            ro.observe(child)
            child.querySelectorAll("*").forEach(node => ro.observe(node))
        })
        window.addEventListener("resize", measure)
        return () => {
            ro.disconnect()
            window.removeEventListener("resize", measure)
            if (raf) cancelAnimationFrame(raf)
        }
    }, [ref, isOpen])

    useEffect(() => {
        if (!isOpen) {
            setOverflow("hidden")
            return
        }
        setOverflow("hidden")
        const timer = setTimeout(() => setOverflow("visible"), TRANSITION_MS)
        return () => clearTimeout(timer)
    }, [isOpen, height])

    return { height, overflow }
}
